const localStorageConstants = {
  accessToken: "accessToken",
  userId: "userId",
  selectedTimezone: "selectedTimezone",
};

export default localStorageConstants;
